<section class="c2">
  <div class="container c2">
    <div class="title c2">
      <small>{{ 'getting_your_order' | translate: lang }}</small>
      <h2>{{ 'start_ranking' | translate: lang }}</h2>
    </div>
    <div class="faq c2">
      <div class="card faq-box c2">
        <div class="ico c2" style="--i: #345fdb">
          <i class="uil uil-lightbulb-alt">1</i>
        </div>
        <div>
          <h3>{{ 'customize_your_service' | translate: lang }}</h3>
          <p>
            {{ step1[lang]?.[game] || step1['en'][game] }}
          </p>
          <img height="399px" [lazyLoad]="'https://cdn.ggboost.com/images/' + game + '/step1.webp'" [alt]="game + ' customize service'">
        </div>
      </div>
      <div class="card faq-box c2">
        <div class="ico c2" style="--i: #ff5353">
          <i class="uil uil-lightbulb-alt">2</i>
        </div>
        <div>
          <h3>{{ 'complete_your_payment' | translate: lang }}</h3>
          <p>
            {{ 'select_your_desired_payment_method' | translate: lang }}
          </p>
          <img style="opacity: 0.8;" [lazyLoad]="'https://cdn.ggboost.com/images/step2.webp'" [alt]="'payment methods'">
        </div>
      </div>
      <div class="card faq-box c2">
        <div class="ico c2" style="--i: #2ec565">
          <i class="uil uil-lightbulb-alt">3</i>
        </div>
        <div>
          <h3>{{ 'start_ranking_up' | translate: lang }}</h3>
          <p>
            {{ 'order_ready_to_go' | translate: lang }}
          </p>
          <img [lazyLoad]="'https://cdn.ggboost.com/images/' + game + '/step3.webp'" [alt]="game + ' rank up'">
        </div>
      </div>
    </div>
  </div>
</section>